function getValueFromPercentage(percentage, maxValue = 1, minValue = 0) {
  return percentage * (maxValue - minValue) + minValue;
}
function getNormalizedValueFromPercentage(percentage, maxValue = 1, minValue = 0) {
  const normalizedPercentage = Math.min(1, Math.max(0, percentage));
  return getValueFromPercentage(normalizedPercentage, maxValue, minValue);
}
function getPercentageFromValue(value, maxValue = 1, minValue = 0) {
  return maxValue ? (value - minValue) / (maxValue - minValue) : 0;
}
function getNormalizedPercentageFromValue(value, maxValue = 1, minValue = 0) {
  const percentage = getPercentageFromValue(value, maxValue, minValue);
  return Math.max(0, Math.min(1, percentage));
}
function percentageToCSSValue(percentage) {
  return `${percentage * 100}%`;
}

export { getNormalizedPercentageFromValue, getNormalizedValueFromPercentage, getPercentageFromValue, getValueFromPercentage, percentageToCSSValue };
//# sourceMappingURL=index.js.map
